import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-partnership-navigation',
    templateUrl: './partnership-navigation.component.html',
    standalone: false
})
export class PartnershipNavigationComponent implements OnInit {

  @Input()
  isCSP: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
